// import { useState, useEffect } from "react";
// import {
//     Box,
//     Typography,
//     CircularProgress,
// } from "@mui/material";
// import { useTheme } from "@mui/material/styles";

// import CustomButton from "../../components/common/CustomButton";
// import CustomInput from "../../components/common/CustomInput";
// import CustomSnackbar from "../../components/common/CustomSnackbar";

// import Cybermeru from "../../assets/images/merubot_logo.png";
// import LoginIllustration from "../../assets/images/login_illustration.png";

// import { userApi } from "../../api/userApi";
// import { emailRule } from "../../components/validator/commonRules";
// import { useAuth } from "../../contexts/AuthContext";

// const RedirectLogin = () => {
//     const theme = useTheme();
//     const { setAuthData, login_lock_until } = useAuth();
//     const [email, setEmail] = useState("");
//     const [errors, setErrors] = useState({});
//     const [loading, setLoading] = useState(false);
//     const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "info", });
//     const [redirecting, setRedirecting] = useState(false);

//     useEffect(() => {
//         const handlePageShow = () => {
//             setRedirecting(false);
//             setLoading(false);
//             setSnackbar((prev) => ({ ...prev, open: false }));
//         };
//         window.addEventListener("pageshow", handlePageShow);
//         return () => window.removeEventListener("pageshow", handlePageShow);
//     }, []);

//     const handleSnackbar = (message, severity = "info") => setSnackbar({ open: true, message, severity });

//     const handleChange = (e) => {
//         const value = e.target.value?.trim()?.toLowerCase();
//         setEmail(value);
//         if (!value) {
//             setErrors((prev) => ({ ...prev, email: "" }));
//             return;
//         }
//         try {
//             emailRule("Email address", { required: true }).validateSync(value);
//             setErrors((prev) => ({ ...prev, email: "" }));
//         } catch (err) {
//             setErrors((prev) => ({ ...prev, email: err.message }));
//         }
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (loading) return;

//         const normalizedEmail = email.trim().toLowerCase();
//         setEmail(normalizedEmail);

//         try {
//             emailRule("Email address", { required: true }).validateSync(normalizedEmail);
//             setErrors({});
//         } catch (err) {
//             setErrors({ email: err.message });
//             return;
//         }

//         setLoading(true);

//         try {
//             const response = await userApi.getRedirectLink({ email: normalizedEmail });
//             // console.log("Redirect Response::", response);
//             const { status, data, message } = response || {};
//             const redirectLink = data?.data?.link;

//             if (status === 0) {
//                 handleSnackbar(
//                     "Network error. Please check your connection.",
//                     "warning"
//                 );
//                 return;
//             }

//             if (status !== 200) {
//                 handleSnackbar(
//                     message || "Unable to find organization.",
//                     "error"
//                 );
//                 return;
//             }

//             if (redirectLink) {
//                 setAuthData({ login_lock_until: { ...login_lock_until, [normalizedEmail]: null } });
//                 setRedirecting(true);

//                 let finalRedirectLink = redirectLink;
//                 try {
//                     const url = new URL(redirectLink, window.location.origin);
//                     url.searchParams.set("email", normalizedEmail);
//                     finalRedirectLink = url.toString();
//                 } catch (error) {
//                     handleSnackbar(message || "Invalid redirect URL format", "warning");
//                     console.error("Error constructing redirect URL with email:", error);
//                 }

//                 setEmail("");
//                 setErrors({});

//                 handleSnackbar("Redirecting to password page...", "success");

//                 setTimeout(() => {
//                     window.location.replace(finalRedirectLink);
//                     setRedirecting(false);
//                     setLoading(false);
//                 }, 1000);
//                 return;
//             }

//             handleSnackbar(
//                 "Redirect link not found.",
//                 "error"
//             );

//         } catch (error) {
//             console.error("Redirect Error::", error);

//             handleSnackbar(
//                 "Something went wrong. Please try again.",
//                 "error"
//             );
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <Box
//             sx={{
//                 minHeight: "100vh",
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 background: theme.palette.background.grad,
//                 p: 2,
//                 pb: 3,
//             }}
//         >
//             <Box
//                 sx={{
//                     display: "flex",
//                     width: "100%",
//                     maxWidth: 900, // Reduced from 1000
//                     borderRadius: 4,
//                     overflow: "hidden",
//                     boxShadow: theme.shadows[6],
//                     background: theme.palette.background.paper,
//                 }}
//             >
//                 {/* LEFT SIDE */}
//                 <Box
//                     sx={{
//                         flex: 1,
//                         p: 3.5, // Reduced from 4
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                     }}
//                 >
//                     <form
//                         onSubmit={handleSubmit}
//                         style={{
//                             width: "100%",
//                             maxWidth: 324, // Reduced from 360
//                         }}
//                     >
//                         {/* LOGO */}
//                         <Box textAlign="center">
//                             <Box
//                                 component="img"
//                                 src={Cybermeru}
//                                 alt="CyberMeru"
//                                 sx={{
//                                     height: 63, // Reduced from 70
//                                     mb: 1.3, // Reduced from 1.5
//                                     mx: "auto",
//                                 }}
//                             />

//                             <Typography
//                                 variant="h5"
//                                 sx={{
//                                     fontSize: "1.35rem", // Explicitly reduced by ~10% from default 1.5rem
//                                     fontWeight: 700,
//                                     mb: 0.9, // Reduced from 1
//                                     color: theme.palette.text.primary,
//                                 }}
//                             >
//                                 Sign in to your workspace
//                             </Typography>

//                             <Typography
//                                 variant="body2"
//                                 sx={{
//                                     mb: 2.7, // Reduced from 3
//                                     color: theme.palette.text.secondary,
//                                     fontSize: "0.8rem", // Reduced from 0.9rem
//                                 }}
//                             >
//                                 Enter your registered email address to continue
//                             </Typography>
//                         </Box>

//                         <CustomInput
//                             label="Email Address"
//                             name="email"
//                             size="small"
//                             required
//                             value={email}
//                             onChange={handleChange}
//                             error={!!errors.email}
//                             helperText={errors.email}
//                         />

//                         <CustomButton
//                             type="submit"
//                             fullWidth
//                             disabled={loading || redirecting || !email.trim() || Object.values(errors).some((v) => v)}
//                             sx={{
//                                 height: 38, // Reduced from 42
//                                 mt: 1.8, // Reduced from 2
//                                 borderRadius: 3,
//                                 fontWeight: 700,
//                                 textTransform: "none",
//                             }}
//                         >
//                             {loading ? (
//                                 <CircularProgress size={20} color="inherit" /> /* Reduced from 22 */
//                             ) : redirecting ? (
//                                 "Redirecting..."
//                             ) : (
//                                 "Continue"
//                             )}
//                         </CustomButton>

//                         <Typography
//                             variant="body2"
//                             sx={{
//                                 mt: 1.8, // Reduced from 2
//                                 textAlign: "center",
//                                 color: theme.palette.text.secondary,
//                                 fontSize: "0.72rem", // Reduced from 0.8rem
//                             }}
//                         >
//                             Don't have a MeruBot account?{" "}
//                             <a
//                                 href="/tenantRegister"
//                                 style={{
//                                     color: theme.palette.primary.main,
//                                     fontWeight: 600,
//                                     textDecoration: "none",
//                                 }}
//                             >
//                                 Sign Up
//                             </a>
//                         </Typography>
//                     </form>
//                 </Box>

//                 {/* RIGHT SIDE */}
//                 <Box
//                     sx={{
//                         flex: 1,
//                         display: { xs: "none", md: "block" },
//                         background: "#f5f7fb",
//                     }}
//                 >
//                     <Box
//                         component="img"
//                         src={LoginIllustration}
//                         alt="Workspace Login"
//                         sx={{
//                             width: "100%",
//                             height: "100%",
//                             objectFit: "cover",
//                         }}
//                     />
//                 </Box>
//             </Box>

//             {/* FOOTER */}
//             <Typography
//                 component="footer"
//                 sx={{
//                     mt: 4.5, // Reduced from 5
//                     textAlign: "center",
//                     fontSize: "0.68rem", // Reduced from 0.75rem
//                     color: "rgba(35, 33, 33, 0.75)",
//                     letterSpacing: 0.2,
//                 }}
//             >
//                 © {new Date().getFullYear()} CyberMeru Technologies Pvt. Ltd. · All Rights Reserved.
//             </Typography>

//             {/* SNACKBAR */}
//             <CustomSnackbar
//                 open={snackbar.open}
//                 message={snackbar.message}
//                 severity={snackbar.severity}
//                 onClose={() =>
//                     setSnackbar((prev) => ({
//                         ...prev,
//                         open: false,
//                     }))
//                 }
//                 autoHideDuration={5000}
//             />
//         </Box>
//     );
// };

// export default RedirectLogin;


import { useState, useEffect } from "react";
import {
    Box,
    Typography,
    CircularProgress,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

import CustomButton from "../../components/common/CustomButton";
import CustomInput from "../../components/common/CustomInput";
import CustomSnackbar from "../../components/common/CustomSnackbar";
import { useBranding } from "../../hooks/useBranding";

import Cybermeru from "../../assets/images/merubot_logo.png";
import LoginIllustration from "../../assets/images/login_illustration.png";

import { userApi } from "../../api/userApi";
import { authApi } from "../../api/authApi";
import { emailRule } from "../../components/validator/commonRules";
import { GoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const RedirectLogin = () => {
    const theme = useTheme();
    const { setAuthData, login_lock_until } = useAuth();
    const navigate = useNavigate()
    const { handleContextLogin } = useBranding();
    const routeMap = {
        user: "/user/landing",
        recruiter: "/recruiter/dashboard",
        admin: "/admin/dashboard",
        freelancer: "/recruiter/dashboard",
        superadmin: "/superadmin/dashboard",
        candidate: "/candidate/landing",
    };

    /* ---------------- Helpers ---------------- */
    const deriveCentralUrl = () => {
        const apiUrl = process.env.REACT_APP_API_URL;
        if (!apiUrl) return "http://dev.localhost:3000";
        if (apiUrl.includes("devapi.merubot.com")) return "https://dev.merubot.com";
        if (apiUrl.includes("testapi.merubot.com")) return "https://test.merubot.com";
        if (apiUrl.includes("api.merubot.com")) return "https://merubot.com";
        return "http://dev.localhost:3000";
    };

    const getTenantUrl = (tenantSlug, path = "") => {
        try {
            const urlObj = new URL(deriveCentralUrl());
            urlObj.hostname = `${tenantSlug}.${urlObj.hostname}`;
            return `${urlObj.origin.replace(/\/$/, "")}${path}`;
        } catch (e) {
            return `http://${tenantSlug}.dev.localhost:3000${path}`;
        }
    };

    const [email, setEmail] = useState("");
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "info", });
    const [redirecting, setRedirecting] = useState(false);

    useEffect(() => {
        const handlePageShow = () => {
            setRedirecting(false);
            setLoading(false);
            setSnackbar((prev) => ({ ...prev, open: false }));
        };
        window.addEventListener("pageshow", handlePageShow);
        return () => window.removeEventListener("pageshow", handlePageShow);
    }, []);

    const handleSnackbar = (message, severity = "info") => setSnackbar({ open: true, message, severity });

    const handleChange = (e) => {
        const value = e.target.value?.trim()?.toLowerCase();
        setEmail(value);
        if (!value) {
            setErrors((prev) => ({ ...prev, email: "" }));
            return;
        }
        try {
            emailRule("Email address", { required: true }).validateSync(value);
            setErrors((prev) => ({ ...prev, email: "" }));
        } catch (err) {
            setErrors((prev) => ({ ...prev, email: err.message }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (loading) return;

        const normalizedEmail = email.trim().toLowerCase();
        setEmail(normalizedEmail);

        try {
            emailRule("Email address", { required: true }).validateSync(normalizedEmail);
            setErrors({});
        } catch (err) {
            setErrors({ email: err.message });
            return;
        }

        setLoading(true);

        try {
            const response = await userApi.getRedirectLink({ email: normalizedEmail });
            // console.log("Redirect Response::", response);
            const { status, data, message } = response || {};
            const redirectLink = data?.data?.link;

            if (status === 0) {
                handleSnackbar(
                    "We are unable to process your request right now. Please try again later.",
                    "warning"
                );
                return;
            }

            if (status !== 200) {
                handleSnackbar(
                    message || "Unable to find organization.",
                    "error"
                );
                return;
            }

            if (redirectLink) {
                setAuthData({ login_lock_until: { ...login_lock_until, [normalizedEmail]: null } });
                setRedirecting(true);

                let finalRedirectLink = redirectLink;
                try {
                    const url = new URL(redirectLink, window.location.origin);
                    url.searchParams.set("email", normalizedEmail);
                    finalRedirectLink = url.toString();
                } catch (error) {
                    handleSnackbar(message || "Invalid redirect URL format", "warning");
                    console.error("Error constructing redirect URL with email:", error);
                }

                setEmail("");
                setErrors({});

                handleSnackbar("Redirecting to password page...", "success");

                setTimeout(() => {
                    // window.location.replace(finalRedirectLink);
                    window.location.href = finalRedirectLink;
                    setRedirecting(false);
                    setLoading(false);
                }, 1000);
                return;
            }

            handleSnackbar(
                "Redirect link not found.",
                "error"
            );

        } catch (error) {
            console.error("Redirect Error::", error);

            handleSnackbar(
                "Something went wrong. Please try again.",
                "error"
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                background: theme.palette.background.grad,
                p: 2,
                pb: 3,
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    width: "100%",
                    maxWidth: 900, // Reduced from 1000
                    borderRadius: 4,
                    overflow: "hidden",
                    boxShadow: theme.shadows[6],
                    background: theme.palette.background.paper,
                }}
            >
                {/* LEFT SIDE */}
                <Box
                    sx={{
                        flex: 1,
                        p: 3.5, // Reduced from 4
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <form
                        onSubmit={handleSubmit}
                        style={{
                            width: "100%",
                            maxWidth: 324, // Reduced from 360
                        }}
                    >
                        {/* LOGO */}
                        <Box textAlign="center">
                            <Box
                                component="img"
                                src={Cybermeru}
                                alt="CyberMeru"
                                sx={{
                                    height: 63, // Reduced from 70
                                    mb: 1.3, // Reduced from 1.5
                                    mx: "auto",
                                }}
                            />

                            <Typography
                                variant="h5"
                                sx={{
                                    fontSize: "1.35rem", // Explicitly reduced by ~10% from default 1.5rem
                                    fontWeight: 700,
                                    mb: 0.9, // Reduced from 1
                                    color: theme.palette.text.primary,
                                }}
                            >
                                Sign in to your workspace
                            </Typography>

                            <Typography
                                variant="body2"
                                sx={{
                                    mb: 2.7, // Reduced from 3
                                    color: theme.palette.text.secondary,
                                    fontSize: "0.8rem", // Reduced from 0.9rem
                                }}
                            >
                                Enter your registered email address to continue
                            </Typography>
                        </Box>

                        <CustomInput
                            label="Email Address"
                            name="email"
                            size="small"
                            required
                            value={email}
                            onChange={handleChange}
                            error={!!errors.email}
                            helperText={errors.email}
                        />

                        <CustomButton
                            type="submit"
                            fullWidth
                            disabled={loading || redirecting || !email.trim() || Object.values(errors).some((v) => v)}
                            sx={{
                                height: 38, // Reduced from 42
                                mt: 1.8, // Reduced from 2
                                borderRadius: 3,
                                fontWeight: 700,
                                textTransform: "none",
                            }}
                        >
                            {loading ? (
                                <CircularProgress size={20} color="inherit" /> /* Reduced from 22 */
                            ) : redirecting ? (
                                "Redirecting..."
                            ) : (
                                "Continue"
                            )}
                        </CustomButton>

                        <Box sx={{ mt: 2, display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <Typography
                                sx={{
                                    fontSize: "0.75rem",
                                    color: "text.disabled",
                                    fontWeight: 600,
                                    mb: 1.5,
                                }}
                            >
                                OR
                            </Typography>
                            <GoogleLogin
                                ux_mode="popup"
                                onSuccess={async (credentialResponse) => {
                                    try {
                                        setLoading(true);

                                        const response = await authApi.googleLogin({
                                            token: credentialResponse.credential,
                                        });


                                        // response shape: { status, data: { status, message, data: { user_type, tenant_slug, access?, refresh? } } }
                                        const apiStatus = response?.status;
                                        const apiData = response?.data || {};
                                        const message = apiData?.message;
                                        const data = apiData?.data || {};

                                        if (apiStatus !== 200) {
                                            handleSnackbar(message || "Google login failed", "error");
                                            return;
                                        }

                                        if (message && message.includes("You have been logged out due to inactivity")) {
                                            handleSnackbar(message, "error");
                                            return;
                                        }

                                        const userType = data?.user_type;
                                        const tenantSlug = data?.tenant_slug || data?.tenant || data?.subdomain;
                                        // Tokens are present only if backend puts them in the response data
                                        const accessToken = data?.access;
                                        const refreshToken = data?.refresh;

                                        if (!userType) {
                                            handleSnackbar("Login failed: user type missing.", "error");
                                            return;
                                        }

                                        // Normalize backend typo
                                        const normalizedUserType = userType === "freelanceer" ? "freelancer" : userType;

                                        handleSnackbar(message || "Login successful!", "success");

                                        // ── superadmin: go to central domain ──
                                        if (normalizedUserType === "superadmin") {
                                            setAuthData({ isAuthenticated: true, user_type: normalizedUserType, plan: data?.plan || "free" });
                                            handleContextLogin();
                                            window.location.href = deriveCentralUrl() + (routeMap["superadmin"] || "/");
                                            return;
                                        }

                                        const path = routeMap[normalizedUserType] || "/recruiter/dashboard";

                                        // ── BEST: Token-in-URL handoff via /auth/callback ──
                                        // Works on ALL environments (localhost, lvh.me, merubot.com)
                                        // Requires backend to include access + refresh in the JSON response data
                                        if (tenantSlug && accessToken && refreshToken) {
                                            const callbackUrl =
                                                getTenantUrl(tenantSlug, "/auth/callback") +
                                                `?access=${accessToken}&refresh=${refreshToken}&user_type=${normalizedUserType}`;
                                            window.location.replace(callbackUrl);
                                            return;
                                        }

                                        // ── FALLBACK: Cookie-based redirect (only works if cookie domain is set correctly) ──
                                        // This will FAIL on localhost due to Chrome's subdomain cookie policy.
                                        // Fix: add access+refresh to your backend's encrypted_response data dict.
                                        if (tenantSlug) {
                                            setAuthData({ isAuthenticated: true, user_type: normalizedUserType });
                                            handleContextLogin();
                                            window.location.replace(getTenantUrl(tenantSlug, path));
                                            return;
                                        }

                                        // ── No tenant: same-domain navigation ──
                                        setAuthData({ isAuthenticated: true, user_type: normalizedUserType });
                                        handleContextLogin();
                                        navigate(path, { replace: true });

                                    } catch (err) {
                                        console.error(err);
                                        handleSnackbar("Google login failed", "error");
                                    } finally {
                                        setLoading(false);
                                    }
                                }}
                                onError={() => {
                                    handleSnackbar("Google authentication failed", "error");
                                }}
                            />
                        </Box>

                        <Typography
                            variant="body2"
                            sx={{
                                mt: 1.8, // Reduced from 2
                                textAlign: "center",
                                color: theme.palette.text.secondary,
                                fontSize: "0.72rem", // Reduced from 0.8rem
                            }}
                        >
                            Don't have a MeruBot account?{" "}
                            <a
                                href="/tenantRegister"
                                style={{
                                    color: theme.palette.primary.main,
                                    fontWeight: 600,
                                    textDecoration: "none",
                                }}
                            >
                                Sign Up
                            </a>
                        </Typography>
                    </form>
                </Box>

                {/* RIGHT SIDE */}
                <Box
                    sx={{
                        flex: 1,
                        display: { xs: "none", md: "block" },
                        background: "#f5f7fb",
                    }}
                >
                    <Box
                        component="img"
                        src={LoginIllustration}
                        alt="Workspace Login"
                        sx={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                        }}
                    />
                </Box>
            </Box>

            {/* FOOTER */}
            <Typography
                component="footer"
                sx={{
                    mt: 4.5, // Reduced from 5
                    textAlign: "center",
                    fontSize: "0.68rem", // Reduced from 0.75rem
                    color: "rgba(35, 33, 33, 0.75)",
                    letterSpacing: 0.2,
                }}
            >
                © {new Date().getFullYear()} CyberMeru Technologies Pvt. Ltd. · All Rights Reserved.
            </Typography>

            {/* SNACKBAR */}
            <CustomSnackbar
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={() =>
                    setSnackbar((prev) => ({
                        ...prev,
                        open: false,
                    }))
                }
                autoHideDuration={5000}
            />
        </Box>
    );
};

export default RedirectLogin;